import { SxProps, Theme } from '@mui/material';
import { TEXT_SECONDARY } from '../../../../styles/GlobalStyles';
import { sharedCardStyles } from '../SharedCard.styles';

export const collectionCardStyles = {
  container: (theme: Theme) =>
    ({
      ...sharedCardStyles.card(theme, { direction: 'row', cursor: 'pointer' }),
      '&:hover': {
        borderColor: 'transparent',
      },
    }) as SxProps<Theme>,

  assignExperienceToggle: (theme: Theme) =>
    ({
      position: 'absolute',
      top: '12px',
      right: theme.spacing(1),
      zIndex: 1,
      color: TEXT_SECONDARY,
      marginRight: 0,
      backgroundColor: theme.palette.background.paper,
      paddingRight: theme.spacing(0.5),
      alignItems: 'center',
      '& .MuiFormControlLabel-label': {
        fontSize: theme.typography.body2.fontSize,
        fontWeight: 400,
        lineHeight: '22px',
        color: TEXT_SECONDARY,
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: TEXT_SECONDARY,
      },
      '& .MuiCheckbox-root': {
        padding: 0,
        marginRight: theme.spacing(0.75),
        alignSelf: 'center',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '22px',
      },
    }) as SxProps<Theme>,

  imageContainer: (theme: Theme) =>
    ({
      ...sharedCardStyles.imageContainer(theme),
    }) as SxProps<Theme>,

  image: (_theme: Theme) =>
    ({
      ...sharedCardStyles.image(),
    }) as SxProps<Theme>,

  contentContainer: (theme: Theme, hasAssignExperienceToggle: boolean = false) =>
    ({
      ...sharedCardStyles.contentContainer(
        theme,
        hasAssignExperienceToggle ? theme.spacing(1, 23, 1, 1.25) : theme.spacing(1, 8, 1, 1.25)
      ),
    }) as SxProps<Theme>,

  title: (theme: Theme) =>
    ({
      ...sharedCardStyles.title(theme),
    }) as SxProps<Theme>,

  description: (theme: Theme, maxLines: number = 3) => {
    return ({
      ...sharedCardStyles.description(theme, maxLines),
    }) as SxProps<Theme>;
  },
};

export default collectionCardStyles;
